export default "__VITE_ASSET__66971907__"